import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DATE_FORMATS } from '@callmart/types';
import UserContext from '../../store/User/UserContext';
import { getCallCenterPotentialsByDateRangeLocationAndWorktype } from '../../services/callCenterPotential';
import { getFirstDayOfMonth, getLastDayOfMonth } from '../../utils/dateUtils';
import DownloadExcelButton from '../Buttons/DownloadExcelButton';
import { usePreferredUserLocation } from '../../hooks';
import dayjs, { formatSlotTime } from '@utils/dayjs';

const columnNames = ['START_TIME', 'HOUR', 'MINUTE', 'Potential', 'Stadt', 'Standort Detail', 'Worktype', 'Kanal'];

function PotentialsCurrentDataDownloadButton({ date, selectedLocation, worktypes }) {
    const { t } = useTranslation();
    const loggedInUser = useContext(UserContext);
    const [location] = usePreferredUserLocation(selectedLocation);

    const getXLSXSheets = async (worktypes) => {
        const sheetsData = [];
        for (let i = 0; i < worktypes.length; i++) {
            const sheetData = [];

            const firstDayOfMonth = getFirstDayOfMonth(date);
            const lastDayOfMonth = getLastDayOfMonth(date);

            const potentials = await getCallCenterPotentialsByDateRangeLocationAndWorktype(
                firstDayOfMonth,
                lastDayOfMonth,
                loggedInUser.primaryLocation.id,
                worktypes[i].id
            );

            for (let j = 0; j < potentials.length; j++) {
                const start_time = formatSlotTime(potentials[j].slotDate, DATE_FORMATS.DATE);
                const hour = parseInt(formatSlotTime(potentials[j].slotDate, 'HH'));
                const minute = parseInt(formatSlotTime(potentials[j].slotDate, 'mm'));
                const potentialValue = potentials[j].potentialValue;
                const channel = potentials[j].channelName ? potentials[j].channelName : '';
                const row = [
                    start_time,
                    hour,
                    minute,
                    potentialValue,
                    loggedInUser.primaryLocation.city,
                    loggedInUser.primaryLocation.code,
                    worktypes[i].worktype,
                    channel,
                ];
                sheetData.push(row);
            }

            sheetsData.push({
                sheetName: worktypes[i].worktype,
                sheetData: sheetData,
            });
        }

        return sheetsData;
    };

    return (
        <DownloadExcelButton
            title="Potenziale Template"
            fileName={`potenziale_${location?.city}_${dayjs(date).format(DATE_FORMATS.MONTH_YEAR_UNDERSCORE)}.xlsx`}
            location={selectedLocation}
            columnNames={columnNames}
            getSheetsData={() => getXLSXSheets(worktypes)}
            buttonText={t('potentials.templateCurrent')}
        ></DownloadExcelButton>
    );
}

export default PotentialsCurrentDataDownloadButton;
